module.exports = __webpack_public_path__ + "img/parc3@2x.f7d5f772.png";